// Search and link-preview tags for the store being shown.
// Every seller's store runs this same build, so public/index.html only has neutral defaults and the real
// title, description, canonical address and structured data are filled in here once the store has loaded.
// (Google reads these; WhatsApp/Facebook previews only see the defaults in index.html.)

import { money } from "./formatters";
function setMeta(attr, key, content) {
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
}

function setCanonical(href) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }
    link.setAttribute("href", href);
}

function setJsonLd(data) {
    let script = document.getElementById("store-jsonld");
    if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "store-jsonld";
        document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
}

const clip = (text, max) => (text.length > max ? `${text.slice(0, max - 1).trimEnd()}…` : text);

// Store-wide tags: home page title and description, canonical address, Store structured data
export function applyStoreSeo(config, categories = []) {
    if (!config || !config.name) return;
    const url = `${window.location.protocol}//${window.location.host}/`;
    const what = (config.category && config.category !== "General" ? config.category : categories.slice(0, 3).join(", ")) || "products";
    const image = (config.heroBanners && config.heroBanners[0] && config.heroBanners[0].image) || "";

    // The store's SEO (Edit website -> SEO): the owner's own words or the defaults for its kind of store, from the
    // server. Ownezzy's demo stores also mention the free website offer shown on the page.
    const seo = config.seo || {};
    const fallback = `${config.name} – Shop ${what} Online`;
    const title = config.showOwnezzyOffer ? `${seo.title || fallback} | Ownezzy` : seo.title || fallback;
    const description = clip(
        config.showOwnezzyOffer
            ? `${seo.description || `Shop ${what.toLowerCase()} online at ${config.name}.`} This store is a live demo of Ownezzy – get a free website like this for your own shop.`
            : seo.description || `Shop ${what.toLowerCase()} online at ${config.name}. Easy ordering with Cash on Delivery.`,
        160
    );

    document.title = title;
    setMeta("name", "description", description);
    if (seo.keywords && seo.keywords.length) setMeta("name", "keywords", seo.keywords.join(", "));
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", config.name);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setCanonical(url);
    setJsonLd({
        "@context": "https://schema.org",
        "@type": "OnlineStore",
        name: config.name,
        url,
        description,
        ...(image ? { image } : {}),
        ...(config.contact ? { telephone: config.contact } : {}),
        ...(config.email ? { email: config.email } : {}),
        ...(config.address ? { address: config.address } : {}),
    });
}

// Product page: the product's own title and description, back to the store's on leaving
export function applyProductSeo(config, product) {
    if (!config || !product) return;
    const title = `${product.name} – Buy Online at ${config.name}`;
    const description = clip(`${product.name}${product.desc ? `: ${product.desc}` : ""}. Price ${money(product.price)}. Order online from ${config.name}.`, 160);
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (product.img) setMeta("property", "og:image", product.img);
}
